import { RootState } from '@store/reducers';
import React, { Dispatch, SetStateAction } from 'react'
import { useSelector } from 'react-redux';
import { Modal } from "react-bootstrap";
import '../beneficiary.css';
import VerificationAbha from './Abha';
import VerificationPhoneNumber from './PhoneNumber';
import AadharModal from './Aadhar';
import { benef_const } from '@constants/beneficiaryConstant';
import { updateChild } from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';


interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string) => void;
    setLinkedBenefDetails:Dispatch<SetStateAction<string>>;
};
const VerificationModal = ({ showModal, handleClose, setLinkedBenefDetails}: showModalProps) => {
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const dispatch = useDispatch();

    const handleAuthClick = (authType: string) => {
        handleClose(authType);
    };

    function handleBackClick(): void {
        handleClose('back');
    }

    function handleDiscardClick(): void {
        handleAuthClick('');
        dispatch(updateChild('isChildRegistration', false));
    }
    

    return (
        <>
            <div className="modal_verification_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleAuthClick('')}
                    dialogClassName={'verification-card-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            {beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha && <VerificationAbha handleClose={handleAuthClick} />}
                            {beneficiary?.beneficiaryRedgeOption ===  benef_const.verifyOptions.phoneNumber && <VerificationPhoneNumber handleClose={handleAuthClick} setLinkedBenefDetails={setLinkedBenefDetails}/>}
                            {beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && <AadharModal handleClose={handleAuthClick} setLinkedBenefDetails={setLinkedBenefDetails}/>}
                            {beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication && beneficiary?.beneficiaryAuthType === 'Face_Auth_Creation' && <AadharModal handleClose={handleAuthClick} setLinkedBenefDetails={setLinkedBenefDetails}/>}
                            {beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication && beneficiary?.beneficiaryAuthType !== 'Face_Auth_Creation' && <VerificationPhoneNumber handleClose={handleAuthClick} setLinkedBenefDetails={setLinkedBenefDetails}/>}
                        </>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default VerificationModal;